import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import { Report } from '@/types/report';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'>;

export const getReports = async (
  scope: RequestScope,
  { limit = 500, page = 1 }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<Report[]>> => {
  try {
    const response = await scopedApi(scope).get<EndpointResponse<Report[]>>(`/reports?sort=created_at:-1&limit=${limit}&page=${page}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
